import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router, RouterModule } from "@angular/router";
import { AuthService, NewPasswordRequiredError } from "../core/auth.service";

@Component({
  selector: "app-login-page",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, RouterModule],
  templateUrl: "./login-page.component.html",
  styleUrls: ["./login-page.component.scss"],
})
export class LoginPageComponent {
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);

  email = "";
  password = "";
  newPassword = "";
  error = signal<string | null>(null);
  loading = signal(false);
  needsNewPassword = signal(false);
  private completeNewPassword: ((p: string) => Promise<void>) | null = null;

  async submit() {
    this.error.set(null);
    this.loading.set(true);
    try {
      if (this.needsNewPassword()) {
        await this.completeNewPassword?.(this.newPassword);
      } else {
        await this.auth.login(this.email, this.password);
      }
      this.auth.touch();
      this.router.navigate(["/"]);
    } catch (e) {
      if (e instanceof NewPasswordRequiredError) {
        this.completeNewPassword = e.complete;
        this.needsNewPassword.set(true);
      } else {
        this.error.set(
          (e as Error)?.message === "This account is not a supplier."
            ? (e as Error).message
            : this.needsNewPassword()
              ? "Could not set the new password. Try again."
              : "Invalid email or password. Please try again.",
        );
      }
    } finally {
      this.loading.set(false);
    }
  }
}
